/**
 * Where is My Order Page
 */
'use strict';

const gMap = require('../../modules/google').maps;
const gPlaces = require('../../modules/google').places;
const $mapEl = $('.js-google-map');
const whereIsMyOrderFormHandler = require('./whereIsMyOrderFormHandler');

/**
 * Gets data from map element and converts them to coordinates
 */
const initMap = () => {
    if ($mapEl.data('lat') && $mapEl.data('lng')) {
        gMap.init($mapEl);
        return;
    }

    const postalCode = String($mapEl.data('postalcode') || '');
    const countryName = $mapEl.data('country') || '';

    gPlaces.getLatLongFromPostalCode(postalCode, countryName, drawMap);
};

/**
 * Draws the map in the map element using the lat and lng params
 *
 * @param {number} lat lattitude of location
 * @param {number} lng longtitude of location
 */
const drawMap = (lat, lng) => {
    $mapEl.data('lat', lat);
    $mapEl.data('lng', lng);

    gMap.init($mapEl);
};

/**
 * Checks if a map is present
 *
 * @returns {boolean}
 */
const shouldInitMap = () => {
    return $mapEl.length > 0;
};

function bindEvents() {

    $(document).on('click', '.js-track-and-trace-link', function() {
        const link = $(this).data('link');
        if (!link) {
            return;
        }
        window.open(link, '_blank');
    });

    $(document).on('click', '.js-track-and-trace-toaster', function() {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.WIMO_TOASTER_HEADER,
                headingLarge: true
            },
            paragraphs: [
                {
                    text: window.Resources.WIMO_TOASTER_MESSAGE,
                }
            ],
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.WIMO_TOASTER_BUTTON,
                    shouldCloseModal: true
                },
            ],
            row: {
                class: 'center-align'
            },
            closeElement: {
                shouldCloseModal: true
            },
            ctaHolder: {},
            modalLarge: true,
            modalFullWidth: true
        });
    });
}

function appendLeadingZeroes(n){
    if (n <= 9) {
      return '0' + n;
    }
    return n;
}

function setCurrentDate() {
    const $refreshTime = $('.js-refresh-time');
    if (!$refreshTime.length) {
        return;
    }
    const currentDatetime = new Date();
    const formattedDate = appendLeadingZeroes(currentDatetime.getDate())
        + '-' + appendLeadingZeroes(currentDatetime.getMonth() + 1) + '-' + currentDatetime.getFullYear().toString().slice(2) + ' '
        + appendLeadingZeroes(currentDatetime.getHours()) + ':' + appendLeadingZeroes(currentDatetime.getMinutes());
    $refreshTime.text(formattedDate);
}

const whereIsMyOrderPage = {
    init: () => {
        bindEvents();
        whereIsMyOrderFormHandler.init();

        if (shouldInitMap()) {
            initMap();
        }
        setCurrentDate();
    }
};

module.exports = whereIsMyOrderPage;
